import React from 'react';
import { Typography } from '@growthaxl/web-foundation';
import type { MetricBlock } from '../../types';

export interface MetricBlockViewProps {
  block: MetricBlock;
}

export function MetricBlockView({ block }: MetricBlockViewProps): React.ReactElement {
  return (
    <div
      data-testid="block-metric"
      className="border border-border-default rounded-8 px-3 py-2.5 flex flex-col gap-0.5"
    >
      <Typography variant="caption" color="secondary">
        {block.label}
      </Typography>
      <Typography variant="subtitle2" color="primary">
        <span className="text-[20px] font-semibold leading-tight">{block.value}</span>
      </Typography>
      {block.detail && (
        <Typography variant="caption" color="secondary">
          {block.detail}
        </Typography>
      )}
    </div>
  );
}
